import { useMemo } from "react";

interface MovementPRBoardProps {
  data: Record<string, unknown>;
}

interface MovementPR {
  name: string;
  value: number;
  unit: string;
}

export function MovementPRBoard({ data }: MovementPRBoardProps) {
  const movements = useMemo(() => {
    const raw = data.movement_prs as Record<string, { value?: number; unit?: string }> | undefined;
    if (!raw) return [];
    return Object.entries(raw).map(
      ([name, entry]): MovementPR => ({
        name,
        value: entry.value ?? 0,
        unit: entry.unit ?? "kg",
      }),
    );
  }, [data]);

  if (!movements.length) {
    return (
      <div className="rounded-xl border border-border/60 p-4">
        <h3 className="text-sm font-semibold mb-3">Movement PRs</h3>
        <div className="h-[160px] flex items-center justify-center text-muted-foreground text-sm">
          No movement PRs recorded yet.
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-border/60 p-4">
      <h3 className="text-sm font-semibold mb-3">Movement PRs</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {movements.map((mv) => (
          <div
            key={mv.name}
            className="rounded-lg border border-white/[0.06] bg-white/[0.02] p-2.5 text-center"
          >
            <div className="text-[10px] text-muted-foreground uppercase tracking-wider truncate mb-1">
              {mv.name}
            </div>
            <div className="text-sm font-bold tabular-nums text-foreground">
              {mv.value}
              <span className="text-[10px] text-muted-foreground ml-0.5">{mv.unit}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
